export enum NotificationType {
    info = 'INFO',
    maintenance = 'MAINTENANCE',
    bug = 'BUG',
}

export interface NotificationModel {
    notificationId: string;
    notificationType: NotificationType;
    tenantId?: string;
    title: string;
    content?: string;
    isVisibleLogin: boolean;
    isVisible: boolean;
    updatedAt: string;
    createdAt: string;
}
export interface NotificationsModel extends Array<NotificationModel> {}
